var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"content"},[_c('h2',[_vm._v("ROOM AND BOARD ACCOMMODATION")]),_c('h4',[_vm._v("The pre-assigned type of hospital room and board by HMI to the Member based on the benefit and coverage of the health care plan under this Agreement.")])])
}]

export { render, staticRenderFns }